// extracted by mini-css-extract-plugin
export default {"beef_product_img":"BeefPrimal_beef_product_img__iPN5n","beef_product_img_container":"BeefPrimal_beef_product_img_container__-qfZh"};